<div>
    <img [width]="width ? width : 190" [height]="height ? height : 153" src="assets/imgs/empty.svg" alt="empty image">
    <h1>Whoops!</h1>
    <p class="empty__text">Data seems to be empty!!</p>
</div>
